import { GetTokenResult } from 'features/v2a/receiver/helpers/V2A.helpers';
import React, { createContext, ReactNode, useState } from 'react';

interface V2AReceiverProps {
  paymentDetails?: GetTokenResult;
  setPaymentDetails: (paymentDetails: GetTokenResult) => void;
}

export const V2AReceiverContext = createContext<V2AReceiverProps>({
  paymentDetails: undefined,
  setPaymentDetails: () => {},
});

export const V2AReceiverContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [paymentDetails, setPaymentDetails] = useState<
    GetTokenResult | undefined
  >(undefined);

  return (
    <V2AReceiverContext.Provider
      value={{
        paymentDetails,
        setPaymentDetails,
      }}
    >
      {children}
    </V2AReceiverContext.Provider>
  );
};
